import { useState, useEffect } from "react"
import styles from "../../assets/css/road_ahead_talks/newsletter.module.css"
import RANewsletter from "../../assets/img/Road_Ahead_Newsletter_March_Issue.webp"
import Form from "../../components/Forms/Form"
import { useNavigate } from "react-router-dom"
import SciativeLogo from "./../../assets/img/sciative_logo_white.webp"
import axios from "axios"
import { toast } from "react-toastify"
import Modal from "react-bootstrap/Modal"
import CloseIcon from "@mui/icons-material/Close"
import { Helmet, HelmetProvider } from "react-helmet-async"
import ShortStories from "../../components/common/ShortStories"
import { GlobalUrl, GlobalImg } from "../../global"
import Contributor from "../../components/common/contributor"
// Remove this line:
// import { newsLetterCategories } from "../../data/blogCategories.js"
import { fetchToken } from "../../Auth"

const RoadAheadNewsletter = () => {
  const [guestModal, setGuestModal] = useState(false)
  const [categories, setCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("All topics")
  const [filterState, setFilterState] = useState("all")
  const [filter, setFilter] = useState("all")
  const navigate = useNavigate()

  // State for newsletters data
  const [defaultNewsletters, setDefaultNewsletters] = useState([])
  const [newsletterItems, setNewsletterItems] = useState([])
  const [newsletterImages, setNewsletterImages] = useState({})
  const [latestNewsletterImage, setLatestNewsletterImage] = useState(null)
  const [loading, setLoading] = useState(false)

  // Fetch newsletters from API
  const getNewsletters = async () => {
    try {
      const response = await axios.get(`/backend/get_newsletters/1`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })

      const newsletters = response.data || []
      setDefaultNewsletters(newsletters)
      setNewsletterItems(newsletters)

      // Fetch categories
      try {
        const categoriesResponse = await axios.get(`/backend/get_newsletter_categories`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
          },
        })

        // Add "All topics" category and set it as default
        const fetchedCategories = ["All topics", ...categoriesResponse.data]
        setCategories(fetchedCategories)
      } catch (categoryErr) {
        console.error("Error fetching categories:", categoryErr)
      }

    } catch (err) {
      console.log(err)
      console.error("Error", err)
      if (err.response?.status === 401) {
        console.error("Error", err)
        if (err.response.status === 400) {
          navigate("/error")
        }
        if (err.response.status === 401) {
          navigate("/login")
        }
      }
    }
  }

  // Fetch newsletter image
  const fetchNewsletterImage = async (item) => {
    try {
      const itemId = item.id
      // Find the newsletter item to get its image type
      const imgId = `img-${itemId}`

      // Get the file extension from the image type
      let fileExtension = "jpg" // Default extension
      if (item && item[imgId]?.type) {
        const imageType = item[imgId].type
        if (imageType === "image/jpeg" || imageType === "image/jpg") {
          fileExtension = "jpeg"
        } else if (imageType === "image/png") {
          fileExtension = "png"
        } else if (imageType === "image/gif") {
          fileExtension = "gif"
        }
      }
      const imageID = `newsletter-${itemId.toString()}-${imgId}.${fileExtension}`

      // Updated URL format to include the file extension
      const response = await axios.get(`/backend/get_newsletter_image/${imageID}`, {
        headers: {
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      })

      // Store the image URL in state
      setNewsletterImages((prev) => ({
        ...prev,
        [itemId]: response.data,
      }))

      return response.data // This should be the presigned URL
    } catch (error) {
      console.error(`Error fetching image for newsletter item ${item.id}:`, error)
      return null
    }
  }

  // Handle opening PDF for preview
 // Updated handleOpenPdf function
 const handleOpenPdf = async (itemId) => {
  try {
    setLoading(true);
    const pdfId = `pdf-${itemId}`;
    const pdfFileName = `newsletter-${itemId.toString()}-${pdfId}.pdf`;

    const response = await axios.get(`/backend/preview_newsletter_pdf/${pdfFileName}`, {
      headers: {
        Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
      },
    });

    if (response.data && response.data.preview_url) {
      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = response.data.preview_url;
      link.download = response.data.title; // Set the file name for the download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up
    } else {
      toast.error("Error loading PDF. Please try again.");
    }
  } catch (error) {
    console.error("Error fetching PDF for download:", error);
    toast.error("Error downloading PDF. Please try again.");
  } finally {
    setLoading(false);
  }
};
  // Load newsletters data
  useEffect(() => {
    getNewsletters()
    // Remove this line: setCategories(newsLetterCategories)
  }, [])

  // Fetch images for newsletters when data changes
  useEffect(() => {
    if (newsletterItems.length > 0) {
      newsletterItems.forEach((item) => {
        fetchNewsletterImage(item).then((imageUrl) => {
          if (item.id === newsletterItems[0].id && imageUrl) {
            setLatestNewsletterImage(imageUrl)
          }
        })
      })
    }
  }, [newsletterItems])

  // Filter newsletters by category
  useEffect(() => {
    if (selectedCategory === "All topics") {
      setNewsletterItems(defaultNewsletters)
    } else {
      setNewsletterItems(defaultNewsletters.filter((newsletter) => newsletter.category === selectedCategory))
    }
  }, [selectedCategory, defaultNewsletters])

  const subscribe_template2_props = {
    template: 2,
    form_name: "road-ahead-talks-subscribe",
    fields: [
      {
        name: "email",
        required: true,
      },
    ],
    recipients_group_id: 1,
    handleApiResponse: (res) => {
      toast.dismiss()
      if (res && res.status && res.status === "success") {
        toast.success("Form submitted successfully!")
      } else {
        toast.error(res.data)
      }
    },
    bg_color: "black",
  }

  const subscribe_template3_props = {
    template: 3,
    form_name: "road-ahead-talks-subscribe",
    content_upper: "Sign up for the freshly brewed content on the Road Ahead Talks series",
    fields: [
      {
        name: "email",
        required: true,
      },
    ],
    recipients_group_id: 1,
    handleApiResponse: (res) => {
      toast.dismiss()
      if (res && res.status && res.status === "success") {
        toast.success("Form submitted successfully!")
      } else {
        toast.error(res.data)
      }
    },
  }

  const guestSpeakerProps = {
    template: 1,
    form_name: "become-a-guest-speaker",
    fields: [
      { name: "name", required: true },
      { name: "email", required: true },
      { name: "company", required: true },
      { name: "topic", required: true },
    ],
    title: "Become Our Guest Speaker",
    content_upper:
      "Got an amazing story to share? Become a featured guest on our podcast and share your insights with our audience. Submit your topic idea and let's make magic together on air.",
    content_lower: "Your voice could reach thousands of eager listeners!",
    recipients_group_id: 1,
    handleApiResponse: (res) => {
      toast.dismiss()
      if (res && res.status && res.status === "success") {
        setGuestModal(false)
        toast.success("Form submitted successfully!")
      } else {
        toast.error(res.data)
      }
    },
  }

  const handleFilter = (filterType) => {
    setFilterState(filterType)
  }

  const [webinars, setWebinars] = useState([])
  const [webinarDisplay, setWebinarDisplay] = useState({
    startIndex: 0,
    endIndex: 0,
  })

  const getWebinars = async () => {
    try {
      const response = await axios.get(`/ra_talks/fetch_all_webinars`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      if (response.status === 200 && response.data !== undefined) {
        const webinars = response.data
        setWebinars(webinars)
        handleFilter("all", webinars)
      }
    } catch (error) {
      if (error.response && error.response.data) {
        console.log(error.response.data.detail)
      } else {
        console.log(error)
        console.log("Unrecognised error occurred. Please try again.")
      }
    }
  }
  const handleRead = async () => {
    if (newsletterItems.length > 0) {
      const latestNewsletter = newsletterItems[0];
      handleOpenPdf(latestNewsletter.id);
    } 
  };
  useEffect(() => {
    getWebinars()
  }, [])

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return ""

    // Parse the date string (assuming format YYYY-MM-DD)
    const [year, month] = dateString.split("-")

    // Array of month names
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]

    // Get month name (month is 0-indexed in JavaScript Date, but 1-indexed in the string)
    const monthName = months[Number.parseInt(month) - 1]

    // Return formatted date
    return `${monthName} ${year}`
  }

  // Add this right before the return statement
  const LoadingOverlay = () => (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
    >
      <div className="spinner-border text-light" role="status"  style={{ color: "#ffc50b" }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )

  return (
    <>
      {loading && <LoadingOverlay />}
      <HelmetProvider>
        <Helmet>
          <title>Road Ahead Newsletter: Your Hub for Pricing Insights | Sciative</title>
          <link rel="canonical" href={GlobalUrl + "/road-ahead-newsletter/"} />
          <meta charset="utf-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="csrf_token" content="" />
          <meta property="type" content="website" />
          <meta name="theme-color" content="#ffffff" />
          <meta name="_token" content="" />
          <meta name="robots" content="noodp" />

          <meta
            name="description"
            content="Stay informed with the Road Ahead Newsletter. Get the latest updates, expert insights, and trends in AI-driven pricing, business analytics, and more."
          />
          <meta property="og:title" content="Road Ahead Newsletter: Your Hub for Pricing Insights | Sciative" />
          <meta name="keywords" content="" />
          <meta content="image/*" property="og:image:type" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:image" content={GlobalImg} />
          <meta property="og:hashtag" content="#ai" />
          <meta property="og:url" content={GlobalUrl + "/road-ahead-newsletter/"} />
          <meta property="og:site_name" content="Sciative Solutions - We Price Right" />
          <meta
            property="og:description"
            content="Stay informed with the Road Ahead Newsletter. Get the latest updates, expert insights, and trends in AI-driven pricing, business analytics, and more."
          />
          <meta property="og:type" content="website" />
        </Helmet>

        <div className={styles.ratalks}>
          <div className={styles.landingSection2}>
            <div className="container roadaheadtalksnews">
              <div className="row">
                <div className="mb-4 col-md-7 col-sm-12">
                  <div className={styles.leftContent}>
                    <h1 className="bold big-head">
                      Road Ahead Newsletters: Pioneering the Future of Bus Transportation
                    </h1>
                    <p>
                      Join us as we pioneer the future of bus transportation with exclusive insights and transformative
                      case studies. Discover how industry leaders are shaping tomorrow's future, leveraging innovation
                      and sustainability to redefine the travel experience.
                    </p>
                    <div>
                        <button
                        onClick={handleRead}
                        className="col-sm-12 col-md-3 subscribe-btn"
                      >
                        Read Now
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-5 col-sm-12">
                  <div className="w-100 d-flex justify-content-center">
                  <img
                        onClick={handleRead}
                        style={{
                          cursor: "pointer",
                          height: "20em",
                          width: "auto",
                        }}
                        src={latestNewsletterImage || "/placeholder.svg"}
                      />
                  </div>
                </div>
              </div>
              <div className="mt-4 row d-flex justify-content-center">
                <div className="col-md-4 col-sm-12 d-flex justify-content-center align-items-center">
                  <div className="w-100 d-flex align-items-center justify-content-around">
                    <p className="thin rtpara">Knowledge Partner</p>
                    <img src={SciativeLogo || "/placeholder.svg"} alt="sciative" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.filterSection}>
            <ul>
              <li className={`${filter === "all" ? styles.activeFilter : ""}`}>
                <span>Road Ahead NewsLetter</span>
              </li>
              <li
                onClick={() => navigate("/road-ahead-talks")}
                className={`${filter === "recent" ? styles.activeFilter : ""}`}
              >
                <span>Road Ahead Talks</span>
              </li>
            </ul>
          </div>

          <div className="mb-3 filter-section w-100 d-flex align-items-center justify-content-center flex-wrap">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`mx-1 ${selectedCategory === cat ? "selected" : ""}`}
              >
                {cat === "All topics" ? cat : cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          <div className={styles.container}>
            { newsletterItems.length === 0 ? (
              <div className={styles.textCenter}>
                <span>No newsletters found for this category</span>
              </div>
            ) : (
              <div className={`${styles.cardContainer} newsletterGrid`}>
                {newsletterItems.map((newsletter) => (
                  <div key={newsletter.id} className={styles.card} onClick={() => handleOpenPdf(newsletter.id)}>
                    <div className={styles.imgContainer}>
                      <img
                        src={newsletterImages[newsletter.id] || "/placeholder.svg"}
                        alt={`${newsletter.title}`}
                        className={styles.newsletterCover}
                      />
                    </div>
                    <div className={styles.contentContainer}>
                      <p>{newsletter.title}</p>
                      <span>
                        {newsletter.volume} • {formatDate(newsletter.date)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* guest speaker button */}
          <div className={styles.GuestBtnContainer}>
            <button onClick={() => setGuestModal(true)} className={styles.GuestBtn} type="button">
              Become Our Guest Speaker
            </button>
          </div>
          <div className="p-3 py-1 d-flex flex-sm-column flex-md-row align-items-center mb-5">
            <ShortStories />
          </div>
          {/* form section */}
          <Form {...subscribe_template3_props} />

          <Contributor type="light" />

          <Modal
            show={guestModal}
            onHide={() => setGuestModal(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName="remove-white-bg"
            backdrop="static"
            centered
          >
            <Modal.Body className="p-0">
              <CloseIcon onClick={() => setGuestModal(false)} className="modal-close-icon" />
              <Form {...guestSpeakerProps} />
            </Modal.Body>
          </Modal>
        </div>
      </HelmetProvider>
    </>
  )
}

export default RoadAheadNewsletter

